var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = "${{amount}}";
Shopify.formatMoney = function (cents, format) {
    if (typeof cents == 'string') {
        cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || this.money_format);

    function defaultOption(opt, def) {
        return (typeof opt == 'undefined' ? def : opt);
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
        precision = defaultOption(precision, 2);
        thousands = defaultOption(thousands, ',');
        decimal = defaultOption(decimal, '.');

        if (isNaN(number) || number == null) {
            return 0;
        }

        number = (number / 100.0).toFixed(precision);

        var parts = number.split('.'),
            dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
            cents = parts[1] ? (decimal + parts[1]) : '';

        return dollars + cents;
    }

    switch (formatString.match(placeholderRegex)[1]) {
        case 'amount':
            value = formatWithDelimiters(cents, 2);
            break;
        case 'amount_no_decimals':
            value = formatWithDelimiters(cents, 0);
            break;
        case 'amount_with_comma_separator':
            value = formatWithDelimiters(cents, 2, '.', ',');
            break;
        case 'amount_no_decimals_with_comma_separator':
            value = formatWithDelimiters(cents, 0, '.', ',');
            break;
    }

    return formatString.replace(placeholderRegex, value);
};

$(document).ready(function () {

    // Scroll Header
    $(window).scroll(function () {
        var sticky = $('#shopify-section-header'),
            scroll = $(window).scrollTop();

        if (scroll >= 140) sticky.addClass('fixed'), sticky.addClass('fixed');
        else sticky.removeClass('fixed');
    });

    $(".js-mobile-nav-toggle").click(function () {
        $('body').toggleClass("mobilemenu-opened");
    });

    // Scroll Header End
})

// ACCORDION
$(function () {
    var Accordion = function (el, multiple) {
        this.el = el || {};
        this.multiple = multiple || false;

        var links = this.el.find('.link');
        // Event
        links.on('click', {el: this.el, multiple: this.multiple}, this.dropdown)
    }

    Accordion.prototype.dropdown = function (e) {
        var $el = e.data.el;
        $this = $(this),
            $next = $this.next();

        $next.slideToggle();
        $this.parent().toggleClass('open');

        if (!e.data.multiple) {
            $el.find('.submenu').not($next).slideUp().parent().removeClass('open');
        }
        ;
    }

    var accordion = new Accordion($('.accordion'), false);
});
// ACCORDION END

// ACCORDION FOOTER
$(function () {
    var Accordion = function (el, multiple) {
        this.el = el || {};
        this.multiple = multiple || false;

        var links = this.el.find('.link');
        // Event
        links.on('click', {el: this.el, multiple: this.multiple}, this.dropdown)
    }

    Accordion.prototype.dropdown = function (e) {
        var $el = e.data.el;
        $this = $(this),
            $next = $this.next();

        $next.slideToggle();
        $this.parent().toggleClass('open');

        if (!e.data.multiple) {
            $el.find('.submenu').not($next).slideUp().parent().removeClass('open');
        }
        ;
    }

    var accordion = new Accordion($('.accordion__footer'), false);
});
// ACCORDION FOOTER END

//TAB
$(document).ready(function () {
    $('.tab-a').click(function () {
        $(".tab").removeClass('tab-active');
        $(".tab[data-id='" + $(this).attr('data-id') + "']").addClass("tab-active");
        $(".tab-a").removeClass('active-a');
        $(this).parent().find(".tab-a").addClass('active-a');
    });
});
//END TAB

//Before After

// Call & init
$(window).load(function () {
    $('.ba-slider').each(function () {
        var cur = $(this);
        // Adjust the slider
        var width = cur.width() + 'px';
        cur.find('.resize img').css('width', width);
        cur.find('.resize img').css('display', 'block');
        // Bind dragging events
        drags(cur.find('.handle'), cur.find('.resize'), cur);
    });
});

// Update sliders on resize.
// Because we all do this: i.imgur.com/YkbaV.gif
$(window).resize(function () {
    $('.ba-slider').each(function () {
        var cur = $(this);
        var width = cur.width() + 'px';
        cur.find('.resize img').css('width', width);
    });
});

function drags(dragElement, resizeElement, container) {

    // Initialize the dragging event on mousedown.
    dragElement.on('mousedown touchstart', function (e) {

        dragElement.addClass('draggable_before');
        resizeElement.addClass('resizable');

        // Check if it's a mouse or touch event and pass along the correct value
        var startX = (e.pageX) ? e.pageX : e.originalEvent.touches[0].pageX;

        // Get the initial position
        var dragWidth = dragElement.outerWidth(),
            posX = dragElement.offset().left + dragWidth - startX,
            containerOffset = container.offset().left,
            containerWidth = container.outerWidth();

        // Set limits
        minLeft = containerOffset + 10;
        maxLeft = containerOffset + containerWidth - dragWidth - 10;

        // Calculate the dragging distance on mousemove.
        dragElement.parents().on("mousemove touchmove", function (e) {

            // Check if it's a mouse or touch event and pass along the correct value
            var moveX = (e.pageX) ? e.pageX : e.originalEvent.touches[0].pageX;

            leftValue = moveX + posX - dragWidth;

            // Prevent going off limits
            if (leftValue < minLeft) {
                leftValue = minLeft;
            } else if (leftValue > maxLeft) {
                leftValue = maxLeft;
            }

            // Translate the handle's left value to masked divs width.
            widthValue = (leftValue + dragWidth / 2 - containerOffset) * 100 / containerWidth + '%';

            // Set the new values for the slider and the handle.
            // Bind mouseup events to stop dragging.
            $('.draggable_before').css('left', widthValue).on('mouseup touchend touchcancel', function () {
                $(this).removeClass('draggable_before');
                resizeElement.removeClass('resizable');
            });
            $('.resizable').css('width', widthValue);
        }).on('mouseup touchend touchcancel', function () {
            dragElement.removeClass('draggable_before');
            resizeElement.removeClass('resizable');
        });
        e.preventDefault();
    }).on('mouseup touchend touchcancel', function (e) {
        dragElement.removeClass('draggable_before');
        resizeElement.removeClass('resizable');
    });
}

//End Before After

//Product


// End Product

window.onload = function () {
    // crear_select();
}

function isMobileDevice() {
    return (typeof window.orientation !== "undefined") || (navigator.userAgent.indexOf('IEMobile') !== -1);
};


var li = new Array();
var changeEvent = new Event('change');

function crear_select() {
    var div_cont_select = document.querySelectorAll("[data-mate-select='active']");
    var select_ = '';
    for (var e = 0; e < div_cont_select.length; e++) {
        div_cont_select[e].setAttribute('data-indx-select', e);
        div_cont_select[e].setAttribute('data-selec-open', 'false');
        var ul_cont = document.querySelectorAll("[data-indx-select='" + e + "'] > .cont_list_select_mate > ul");
        select_ = document.querySelectorAll("[data-indx-select='" + e + "'] >select")[0];
//         if (isMobileDevice()) {
//             select_.addEventListener('change', function () {
//                 _select_option(select_.selectedIndex,e);
//             });
//         }
        var select_optiones = select_.options;
        document.querySelectorAll("[data-indx-select='" + e + "']  > .selecionado_opcion ")[0].setAttribute('data-n-select', e);
        document.querySelectorAll("[data-indx-select='" + e + "']  > .icon_select_mate ")[0].setAttribute('data-n-select', e);
        for (var i = 0; i < select_optiones.length; i++) {

            li[i] = document.createElement('li');
            li[i].setAttribute('data-color', select_optiones[i].getAttribute('data-title'))
            li[i].setAttribute('data-index', i);
            li[i].setAttribute('data-selec-index', e);
// funcion click al selecionar
            const value = select_optiones[i].getAttribute('value');
            if (value == '/apps/retextion/#/shop/subscriptions') {
                li[i].addEventListener('click', function () {
                    document.querySelector('.rtxn_manage_subscriptions_btn').click()
                });
            } else {
                li[i].addEventListener('click', function () {
                    _select_option(this.getAttribute('data-index'), this.getAttribute('data-selec-index'));
                });
            }
            li[i].innerHTML = select_optiones[i].innerHTML;
            ul_cont[0].appendChild(li[i]);
            if (select_optiones[i].selected == true || select_.value == select_optiones[i].innerHTML) {
                li[i].className = 'active';
                document.querySelector("[data-indx-select='" + e + "']  > .selecionado_opcion ").innerHTML = select_optiones[i].innerHTML;
                document.querySelectorAll("[data-indx-select='" + e + "'] > .selecionado_opcion")[0].setAttribute("data-color", li[i].getAttribute("data-color"))
            }
            ;
        }
        ; // Fin For select_optiones
    }
    ; // fin for divs_cont_select
} // Fin Function

crear_select();


var cont_slc = 0;

function open_select(idx) {
    console.log('second open')
    var idx1 = idx.getAttribute('data-n-select');
    var ul_cont_li = document.querySelectorAll("[data-indx-select='" + idx1 + "'] .cont_select_int > li");
    var hg = 0;
    var slect_open = document.querySelectorAll("[data-indx-select='" + idx1 + "']")[0].getAttribute('data-selec-open');
    var slect_element_open = document.querySelectorAll("[data-indx-select='" + idx1 + "'] select")[0];
//     if (isMobileDevice()) {
//         if (window.document.createEvent) { // All
//             var evt = window.document.createEvent("MouseEvents");
//             evt.initMouseEvent("mousedown", false, true, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
//             slect_element_open.dispatchEvent(evt);
//         } else if (slect_element_open.fireEvent) { // IE
//             slect_element_open.fireEvent("onmousedown");
//         }else {
//             slect_element_open.click();
//         }
//     }else {


    for (var i = 0; i < ul_cont_li.length; i++) {
        hg += ul_cont_li[i].offsetHeight;
    }
    ;
    if (slect_open == 'false') {
        document.querySelectorAll("[data-indx-select='" + idx1 + "']")[0].setAttribute('data-selec-open', 'true');
        document.querySelectorAll("[data-indx-select='" + idx1 + "'] > .cont_list_select_mate > ul")[0].style.overflow = 'unset';
        document.querySelectorAll("[data-indx-select='" + idx1 + "'] > .icon_select_mate")[0].style.transform = 'rotate(180deg)';
    } else {
        document.querySelectorAll("[data-indx-select='" + idx1 + "']")[0].setAttribute('data-selec-open', 'false');
        document.querySelectorAll("[data-indx-select='" + idx1 + "'] > .icon_select_mate")[0].style.transform = 'rotate(0deg)';
        document.querySelectorAll("[data-indx-select='" + idx1 + "'] > .cont_list_select_mate > ul")[0].style.height = "0px";
        document.querySelectorAll("[data-indx-select='" + idx1 + "'] > .cont_list_select_mate > ul")[0].style.overflow = 'hidden';
    }
//     }

} // fin function open_select

function salir_select(indx) {
    console.log('third')
    var select_ = document.querySelectorAll("[data-indx-select='" + indx + "'] > select")[0];
    document.querySelectorAll("[data-indx-select='" + indx + "'] > .cont_list_select_mate > ul")[0].style.height = "0px";
    document.querySelector("[data-indx-select='" + indx + "'] > .icon_select_mate").style.transform = 'rotate(0deg)';
    document.querySelectorAll("[data-indx-select='" + indx + "']")[0].setAttribute('data-selec-open', 'false');
}


function _select_option(indx, selc) {
//     if (isMobileDevice()) {
//         selc = selc -1;
//     }
    var select_ = document.querySelectorAll("[data-indx-select='" + selc + "'] > select")[0];

    var li_s = document.querySelectorAll("[data-indx-select='" + selc + "'] .cont_select_int > li");
    var title = li_s[indx].getAttribute("data-color");
    var p_act = document.querySelectorAll("[data-indx-select='" + selc + "'] > .selecionado_opcion")[0].innerHTML = li_s[indx].innerHTML;
    var select_color = document.querySelectorAll("[data-indx-select='" + selc + "'] > .selecionado_opcion")[0].setAttribute("data-color", li_s[indx].getAttribute("data-color"))
    var select_optiones = document.querySelectorAll("[data-indx-select='" + selc + "'] > select > option");
    var hidden = document.querySelector('.cont_select_int');
    for (var i = 0; i < li_s.length; i++) {
        if (li_s[i].className == 'active') {
            li_s[i].className = '';
            hidden.style.overflow = 'hidden'
        }
        ;
        li_s[indx].className = 'active';

    }
    ;
    select_optiones[indx].selected = true;
    select_.selectedIndex = indx;
//     select_.onchange();
    select_.dispatchEvent(changeEvent);
    salir_select(selc);
}

// END fin function open_select

// Scroll with animation

(function ($) {


    $.fn.visible = function (partial) {

        var $t = $(this),
            $w = $(window),
            viewTop = $w.scrollTop(),
            viewBottom = viewTop + $w.height(),
            _top = $t.offset().top,
            _bottom = _top + $t.height(),
            compareTop = partial === true ? _bottom : _top,
            compareBottom = partial === true ? _top : _bottom;

        return ((compareBottom <= viewBottom) && (compareTop >= viewTop));
        // console.log(compareBottom <= viewBottom)
    };

})(jQuery);

var win = $(window);

var allMods = $(".module");

allMods.each(function (i, el) {
    var el = $(el);
    if (el.visible(true)) {
        el.addClass("already-visible");
    }
});

win.scroll(function (event) {

    allMods.each(function (i, el) {
        var el = $(el);
        if (el.visible(true)) {
            el.addClass("come-in");
        }
    });
});

//End Scroll


//Variant Product
// $(function () {
//     $('body').on('change', '.product-option-radio', function () {
//         var $this = $(this);
//         var $product_option_select = $this.parent().find('.product-option-select');
//         var $labels = $this.parent().find('label.product-option-label');
//         if ($product_option_select.length == 0) {
//             var $product_option_select = $this.parents('.variant__design-position').find('.product-option-select');
//             $labels = $this.parents('.variant__design-position').find('label.product-option-label');
//         }
//
//         var $currentLabel = $this.next('label.product-option-label');
//         $labels.removeClass('active')
//         $currentLabel.addClass('active')
//
//         $currentLabel.data('value');
//         $this.parents('form').find(".change__color-variant").text($currentLabel.data('value'));
//         $this.parents('form').find(".active__variant-color").text($currentLabel.data('value'));
//         $product_option_select.val(this.value);
//         $product_option_select[0].dispatchEvent(new Event("change"));
//         /*$product_option_select.change();*/
//     })
// });
// End Variant Product


//Reviews Product Page


function productReviews() {
    if ($(".jdgm-rev-widg__summary-stars").length > 0) {
        var rating = $(".jdgm-rev-widg__summary-stars").attr("aria-label");

        var rating_attr = rating.split('is')[1].split('stars')[0];
        $(".jdgm-rev-widg__summary").append("<div class='rating_reviews'>" + rating_attr + "</div>")

        var reviews_result = $('.jdgm-rev-widg__summary-text').text();
        var reviews_split = reviews_result.split('on')[1];
        if (reviews_split != undefined) {
            $(".jdgm-rev-widg__header").append("<div class='reviews_result'>" + reviews_split + "</div>");
        } else {
            $(".jdgm-rev-widg__body").css("padding", "30px");
            $(".jdgm-rev-widg__header").append("<div class='reviews_result'>" + reviews_result + "</div>");
        }
    }
}

function AllReviews() {
    var rating = $(".jdgm-all-reviews__summary-stars").attr("aria-label");
    var rating_attr = rating.split('is')[1].split('stars')[0];
    var text_change = $(".jdgm-all-reviews__summary").append("<div class='rating_reviews'>" + rating_attr + "</div>")

    var reviews_result = $('.jdgm-all-reviews__summary-text').text()
    var reviews_split = reviews_result.split('on')[1];
    var reviews_append = $(".jdgm-all-reviews__header").append("<div class='reviews_result'>" + reviews_split + "</div>")
}

function setSSText(announcementBar, title, price, oldprice, show) {
    const content = document.querySelector('.cart-ss');
    if (content != null) {
        content.remove();
    }
    if (show) {
        const newContent = document.createElement("div");
        newContent.classList.add('cart-ss')
        newContent.innerHTML = `${title} <span class='cart-ss__text'><span class="cart-ss__text-old">${oldprice == 0 ? '' : theme.Currency.formatMoney(oldprice, theme.moneyFormat)}</span> ${oldprice == 0 ? '' : ' - '} ${price == 0 ? '' : theme.Currency.formatMoney(price, theme.moneyFormat)}</span>`;
        announcementBar.appendChild(newContent);
    }
}

const shouldDisplayAnnouncement = () => {
    if (window.Rebuy) {
        const Cart = window.Rebuy.Cart
        const announcementBar = document.querySelector(".rebuy-cart__flyout-footer");
        if (announcementBar != null) {
            const titleSub = 'Subscribe & Save 15%';
            fetch(window.Shopify.routes.root + "?sections=cart-products")
                .then(res => res.json()).then((response) => {
                if (response.hasOwnProperty('cart-products')) {
                    const data = response['cart-products'];
                    const el = new DOMParser().parseFromString(data, 'text/html').querySelector('script');
                    const cartData = JSON.parse(el.innerText);
                    let newPrice = 0
                    let oldPrice = 0;
                    let title = titleSub;
                    let showAnnouncementBar = true;
                    cartData.items.forEach(el => {
                        const group = el?.product?.selling_plan_groups.find(item => item.app_id === "5859381");
                        if (el?.selling_plan_allocation == undefined && group != undefined) {
                            title = group.name;
                            newPrice += el?.variant?.selling_plan_allocations[0].price * el.quantity;
                            oldPrice += el.final_line_price;
                        } else {
                            showAnnouncementBar = false;
                        }
                    });
                    setSSText(announcementBar, title, newPrice, oldPrice, showAnnouncementBar);
                }
            })

        }
    }
}

document.addEventListener('rebuy:cart.init', function (event) {
    shouldDisplayAnnouncement();
});
document.addEventListener('rebuy:cart.ready', function (event) {
    shouldDisplayAnnouncement();
});
document.addEventListener('rebuy:cart.add', function (event) {
    shouldDisplayAnnouncement();
});
document.addEventListener('rebuy:cart.change', function (event) {
    shouldDisplayAnnouncement();
});

shouldDisplayAnnouncement();


let subscribers = {};

function subscribe(eventName, callback) {
    if (subscribers[eventName] === undefined) {
        subscribers[eventName] = [];
    }

    subscribers[eventName] = [...subscribers[eventName], callback];

    return function unsubscribe() {
        subscribers[eventName] = subscribers[eventName].filter((cb) => {
            return cb !== callback;
        });
    };
}

function publish(eventName, data) {
    if (subscribers[eventName]) {
        subscribers[eventName].forEach((callback) => {
            callback(data);
        });
    }
}


const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
    cartUpdate: 'cart-update',
    quantityUpdate: 'quantity-update',
    variantChange: 'variant-change',
    cartError: 'cart-error',
};


class QuantityInput extends HTMLElement {
    constructor() {
        super();
        this.input = this.querySelector('input');
        this.changeEvent = new Event('change', {bubbles: true});
        this.input.addEventListener('change', this.onInputChange.bind(this));
        this.querySelectorAll('button').forEach((button) =>
            button.addEventListener('click', this.onButtonClick.bind(this))
        );
    }

    quantityUpdateUnsubscriber = undefined;

    connectedCallback() {
        this.validateQtyRules();
        this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
    }

    disconnectedCallback() {
        if (this.quantityUpdateUnsubscriber) {
            this.quantityUpdateUnsubscriber();
        }
    }

    onInputChange(event) {
        this.validateQtyRules();
    }

    onButtonClick(event) {
        event.preventDefault();
        const previousValue = this.input.value;
        const parent = this.closest('product-template');
        if (parent != null) {
            const qty = parent.querySelectorAll('quantity-input input');
            qty.forEach(el => {
                event.target.name === 'plus' ? el.stepUp() : el.stepDown();
                if (previousValue !== el.value) el.dispatchEvent(this.changeEvent);
            })
        } else {
            event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
            if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
        }
    }

    validateQtyRules() {
        const value = parseInt(this.input.value);
        if (this.input.min) {
            const min = parseInt(this.input.min);
            const buttonMinus = this.querySelector(".quantity__button[name='minus']");
            buttonMinus.classList.toggle('disabled', value <= min);
            if (value < this.input.min) {
                this.input.value = this.input.min;
            }
        }
        if (this.input.max) {
            const max = parseInt(this.input.max);
            const buttonPlus = this.querySelector(".quantity__button[name='plus']");
            buttonPlus.classList.toggle('disabled', value >= max);
            if (value > this.input.max) {
                this.input.value = this.input.max;
            }
        }
        if (isNaN(value)) {
            if (this.input.min) {
                this.input.value = this.input.min;
            } else {
                this.input.value = 1;
            }
        }
    }
}

customElements.define('quantity-input', QuantityInput);


class VariantSelects extends HTMLElement {
    constructor() {
        super();
        this.addEventListener('change', this.onVariantChange);
    }

    onVariantChange(event) {
        this.updateOptions();
        this.updateMasterId();
        this.updateSelectedSwatchValue(event);
        this.toggleAddButton(true, '', false);
        // this.updatePickupAvailability();
        this.removeErrorMessage();
        this.updateVariantStatuses();

        if (!this.currentVariant) {
            this.toggleAddButton(true, '', true);
            this.setUnavailable();
        } else {
            this.updateURL();
            this.updateVariantInput();
            this.renderProductInfo();
            //     this.updateShareUrl();
            if(this.currentVariant?.available) {
                const wrap = this.closest(".product-details__form");
                if (wrap != null) {
                    wrap.classList.remove("is-sold-out");
                    wrap.querySelector(".product-details__sold-out").style.display = "none";
                }
            }else{
                const wrap = this.closest(".product-details__form");
                if (wrap != null) {
                    wrap.classList.add("is-sold-out");
                    wrap.querySelector(".product-details__sold-out").style.display = "block";
                }
            }
        }
    }

    updateOptions() {
        this.options = Array.from(this.querySelectorAll('select, fieldset'), (element) => {
            if (element.tagName === 'SELECT') {
                return element.value;
            }
            if (element.tagName === 'FIELDSET') {
                return Array.from(element.querySelectorAll('input')).find((radio) => radio.checked)?.value;
            }
        });
    }

    updateMasterId() {
        this.currentVariant = this.getVariantData().find((variant) => {
            return !variant.options
                .map((option, index) => {
                    return this.options[index] === option;
                })
                .includes(false);
        });
    }

    updateSelectedSwatchValue({target}) {
        const {name, value, tagName} = target;

        if (tagName === 'SELECT' && target.selectedOptions.length) {
            const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
            const selectedDropdownSwatchValue = this.querySelector(`[data-selected-dropdown-swatch="${name}"] > .swatch`);
            if (!selectedDropdownSwatchValue) return;
            if (swatchValue) {
                selectedDropdownSwatchValue.style.setProperty('--swatch--background', swatchValue);
                selectedDropdownSwatchValue.classList.remove('swatch--unavailable');
            } else {
                selectedDropdownSwatchValue.style.setProperty('--swatch--background', 'unset');
                selectedDropdownSwatchValue.classList.add('swatch--unavailable');
            }
        } else if (tagName === 'INPUT' && target.type === 'radio') {
            const selectedSwatchValue = this.querySelector(`[data-selected-swatch-value="${name}"]`);
            if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
        }
    }

    updateMedia() {
        if (!this.currentVariant) return;
        if (!this.currentVariant.featured_media) return;

        const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
        mediaGalleries.forEach((mediaGallery) =>
            mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true)
        );

        const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
        if (!modalContent) return;
        const newMediaModal = modalContent.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
        modalContent.prepend(newMediaModal);
    }

    updateURL() {
        if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
        window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
    }

    updateShareUrl() {
        const shareButton = document.getElementById(`Share-${this.dataset.section}`);
        if (!shareButton || !shareButton.updateUrl) return;
        shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
    }

    updateVariantInput() {
        const productForms = document.querySelectorAll(
            `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
        );
        productForms.forEach((productForm) => {
            const input = productForm.querySelector('input[name="id"]');
            input.value = this.currentVariant.id;
            input.dispatchEvent(new Event('change', {bubbles: true}));
        });
    }

    updateVariantStatuses() {
        const selectedOptionOneVariants = this.variantData.filter(
            (variant) => this.querySelector(':checked').value === variant.option1
        );
        const inputWrappers = [...this.querySelectorAll('.product-form__input')];
        inputWrappers.forEach((option, index) => {
            if (index === 0) return;
            const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
            const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
            const availableOptionInputsValue = selectedOptionOneVariants
                .filter((variant) => variant.available && variant[`option${index}`] === previousOptionSelected)
                .map((variantOption) => variantOption[`option${index + 1}`]);
            this.setInputAvailability(optionInputs, availableOptionInputsValue);
        });
    }

    setInputAvailability(elementList, availableValuesList) {
        elementList.forEach((element) => {
            const value = element.getAttribute('value');
            const availableElement = availableValuesList.includes(value);

            if (element.tagName === 'INPUT') {
                element.classList.toggle('disabled', !availableElement);
            } else if (element.tagName === 'OPTION') {
                element.innerText = availableElement
                    ? value
                    : window.variantStrings.unavailable_with_option.replace('[value]', value);
            }
        });
    }

    updatePickupAvailability() {
        const pickUpAvailability = document.querySelector('pickup-availability');
        if (!pickUpAvailability) return;

        if (this.currentVariant && this.currentVariant.available) {
            pickUpAvailability.fetchAvailability(this.currentVariant.id);
        } else {
            pickUpAvailability.removeAttribute('available');
            pickUpAvailability.innerHTML = '';
        }
    }

    removeErrorMessage() {
        const formErrorMsg = document.querySelectorAll('[data-error-message-wrapper]')
        formErrorMsg.forEach(msg => {
            msg.classList.add('product-form__error-message-wrapper--hidden');
        });
    }

    renderProductInfo() {
        const requestedVariantId = this.currentVariant.id;
        const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;

        fetch(
            `${this.dataset.url}?variant=${requestedVariantId}&section_id=${
                this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section
            }`
        )
            .then((response) => response.text())
            .then((responseText) => {
                // prevent unnecessary ui changes from abandoned selections
                if (this.currentVariant.id !== requestedVariantId) return;

                const html = new DOMParser().parseFromString(responseText, 'text/html');
                const destination = document.getElementById(`price-${this.dataset.section}`);
                const source = html.getElementById(
                    `price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
                );
                const skuSource = html.getElementById(
                    `Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
                );
                const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
                const inventorySource = html.getElementById(
                    `Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
                );
                const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);

                const volumePricingSource = html.getElementById(
                    `Volume-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
                );

                const pricePerItemDestination = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
                const pricePerItemSource = html.getElementById(
                    `Price-Per-Item-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
                );

                const qtyItemDestination = document.getElementById(`Quantity-Wrap-${this.dataset.section}`);
                const qtyItemSource = html.getElementById(
                    `Quantity-Wrap-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
                );
                const qtyItemRadioDestination = document.getElementById(`Quantity-Radio-Wrap-${this.dataset.section}`);
                const qtyItemRadioSource = html.getElementById(
                    `Quantity-Radio-Wrap-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
                );

                const qtyStyckyItemDestination = document.getElementById(`Quantity-Sticky-Wrap-${this.dataset.section}`);
                const qtyStyckyItemSource = html.getElementById(
                    `Quantity-Sticky-Wrap-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
                );

                const sliderDestination = document.getElementById(`Slider-Wrap-${this.dataset.section}`);

                const sliderSource = html.getElementById(
                    `Slider-Wrap-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
                );

                const optionTtlDestination = document.querySelector(`.js-option-ttl-${this.dataset.section}`);

                const optionTtlSource = html.querySelector(
                    `.js-option-ttl-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
                );

                const totalPriceItemDestination = document.getElementById(`TotalPrice-${this.dataset.section}`);
                const totalPriceItemSource = html.getElementById(
                    `TotalPrice-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
                );


                const volumePricingDestination = document.getElementById(`Volume-${this.dataset.section}`);
                const qtyRules = document.getElementById(`Quantity-Rules-${this.dataset.section}`);
                const volumeNote = document.getElementById(`Volume-Note-${this.dataset.section}`);

                if (optionTtlSource && optionTtlDestination) {
                    optionTtlDestination.innerHTML = optionTtlSource.innerHTML;
                }
                if (sliderSource && sliderDestination) {
                    const slideIndex = parseInt(sliderSource.getAttribute('data-start'));
                    $(sliderDestination).slick("slickGoTo", slideIndex, true);
                }
                if (volumeNote) volumeNote.classList.remove('hidden');
                if (volumePricingDestination) volumePricingDestination.classList.remove('hidden');
                if (qtyRules) qtyRules.classList.remove('hidden');

                //
                if (source && destination) destination.innerHTML = source.innerHTML;
                if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
                if (skuSource && skuDestination) {
                    skuDestination.innerHTML = skuSource.innerHTML;
                    skuDestination.classList.toggle('hidden', skuSource.classList.contains('hidden'));
                }

                if (volumePricingSource && volumePricingDestination) {
                    volumePricingDestination.innerHTML = volumePricingSource.innerHTML;
                }

                if (pricePerItemSource && pricePerItemDestination) {
                    // pricePerItemDestination.innerHTML = pricePerItemSource.innerHTML;
                    // pricePerItemDestination.classList.toggle('hidden', pricePerItemSource.classList.contains('hidden'));
                }
                if (totalPriceItemSource && totalPriceItemDestination) {
                    totalPriceItemDestination.innerHTML = totalPriceItemSource.innerHTML;
                    totalPriceItemDestination.classList.toggle('hidden', qtyItemSource.classList.contains('hidden'));
                }


                if (qtyStyckyItemSource && qtyStyckyItemDestination) {
                    qtyStyckyItemDestination.innerHTML = qtyStyckyItemSource.innerHTML;
                    qtyStyckyItemDestination.classList.toggle('hidden', qtyStyckyItemSource.classList.contains('hidden'));
                }
                const price = document.getElementById(`price-${this.dataset.section}`);

                if (price) price.classList.remove('hidden');

                if (inventoryDestination) inventoryDestination.classList.toggle('hidden', inventorySource.innerText === '');

                const addButtonUpdated = html.getElementById(`ProductSubmitButton-${sectionId}`);
                if (qtyItemSource && qtyItemDestination) {
                    qtyItemDestination.innerHTML = qtyItemSource.innerHTML;
                    qtyItemDestination.classList.toggle('hidden', qtyItemSource.classList.contains('hidden'));
                }

                if (qtyItemRadioSource && qtyItemRadioDestination) {
                    let isDisabled = true;
                    if (!qtyItemRadioDestination?.querySelector(`[type="radio"]`)?.disabled) {
                        isDisabled = false;
                    }
                    qtyItemRadioDestination.innerHTML = qtyItemRadioSource.innerHTML;
                    qtyItemRadioDestination.classList.toggle('hidden', qtyItemRadioSource.classList.contains('hidden'));
                    if (!isDisabled) {
                        qtyItemRadioDestination?.querySelectorAll(`[type="radio"]`).forEach(el => {
                            el.removeAttribute("disabled");
                        })
                    }
                }

                this.toggleAddButton(
                    addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true,
                    window.variantStrings.soldOut
                );
                publish(PUB_SUB_EVENTS.variantChange, {
                    data: {
                        sectionId,
                        html,
                        variant: this.currentVariant,
                    },
                });
            });
    }

    toggleAddButton(disable = true, text, modifyClass = true) {
        const productForm = document.getElementById(`product-form-${this.dataset.section}`);
        if (!productForm) return;
        const addButton = productForm.querySelector('[name="add"]');
        const addButtonText = productForm.querySelector('[name="add"] > span[data-add-to-cart-text]');
        if (!addButton) return;

        if (disable) {
            addButton.setAttribute('disabled', 'disabled');
            if (text && addButtonText != null) addButtonText.textContent = text;
        } else {
            addButton.removeAttribute('disabled');
            if (addButtonText != null) {
                addButtonText.textContent = window.variantStrings.addToCart;
            }
        }

        if (!modifyClass) return;
    }

    setUnavailable() {
        const button = document.getElementById(`product-form-${this.dataset.section}`);
        const addButton = button.querySelector('[name="add"]');
        const addButtonText = button.querySelector('[name="add"] > span');
        const price = document.getElementById(`price-${this.dataset.section}`);
        const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
        const sku = document.getElementById(`Sku-${this.dataset.section}`);
        const pricePerItem = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
        const volumeNote = document.getElementById(`Volume-Note-${this.dataset.section}`);
        const volumeTable = document.getElementById(`Volume-${this.dataset.section}`);
        const qtyRules = document.getElementById(`Quantity-Rules-${this.dataset.section}`);

        if (!addButton) return;
        addButtonText.textContent = window.variantStrings.unavailable;
        if (price) price.classList.add('hidden');
        if (inventory) inventory.classList.add('hidden');
        if (sku) sku.classList.add('hidden');
        if (pricePerItem) pricePerItem.classList.add('hidden');
        if (volumeNote) volumeNote.classList.add('hidden');
        if (volumeTable) volumeTable.classList.add('hidden');
        if (qtyRules) qtyRules.classList.add('hidden');
    }

    getVariantData() {
        this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
        return this.variantData;
    }
}

customElements.define('variant-selects', VariantSelects);


class QuantityRadioWrap extends HTMLElement {
    constructor() {
        super();
        this.input = this.querySelectorAll('input');
        this.input.forEach(el => {
            el.addEventListener('change', this.onInputChange.bind(this));
        });
        const form = this.closest("form");
        if (form != null) {
            if (form.querySelector('[name="properties[_volume_price_ranges_key]"]')) {
                form.addEventListener("change", (e) => {
                    if (window.theme.addProductsSepparetly == true) {
                        form.querySelector('[name="properties[_volume_price_ranges_key]"]').value = (new Date().getTime()).toString(36) + "" + new Date().getUTCMilliseconds();
                    }
                });
                form.addEventListener("submit", (e) => {
                    if (window.theme.addProductsSepparetly == true) {
                        form.querySelector('[name="properties[_volume_price_ranges_key]"]').value = (new Date().getTime()).toString(36) + "" + new Date().getUTCMilliseconds();
                    }
                });
            }
        }
    }


    onInputChange(event) {
        const input = event.target.closest("form")?.querySelector("input[type='number'][name='quantity']");
        if (input != null) {
            input.value = event.target.value;
            var event = new Event('change');
            input?.dispatchEvent(event);
        }
    }
}

customElements.define('quantity-radio-wrap', QuantityRadioWrap);

